import {
  signInCognito,
  signOutCognito,
  getCognitoUserToken,
  getCurrentCognitoUser,
  getCognitoUserEmail,
  forgotPasswordCognito,
  confirmForgotPasswordCognito,
  updatePasswordCognito
} from '@/cognito'
import api from '@/api'

export const getAuthToken = () => getCognitoUserToken()

export const getAuthUserEmail = () => getCognitoUserEmail()

export const getCurrentAuthUser = async () => {
  const cognitoUser = await getCurrentCognitoUser()
  if (!cognitoUser) return null
  return {
    email: cognitoUser.username,
    uid: cognitoUser.userId || cognitoUser.username,
    emailVerified: true
  }
}

export const authSignIn = (email, password) => signInCognito(email.toLowerCase(), password)

export const authSignUp = (email, password) =>
  api.createCognitoUser({
    operations: [
      { type: 'email', value: email },
      { type: 'password', value: password }
    ]
  })

export const authSignOut = () => signOutCognito()

export const authForgotPassword = (email) => forgotPasswordCognito(email.toLowerCase())

export const authConfirmPasswordReset = ({ email, code, newPassword }) => confirmForgotPasswordCognito(email, code, newPassword)

export const authUpdatePassword = (email, oldPassword, newPassword) => updatePasswordCognito(oldPassword, newPassword)
